import request from '@/router/axios'

export function fetchList(query) {
  return request({
    url: '/basic/admin/words/page',
    method: 'get',
    params: query
  })
}

export function createWords(query) {
  return request({
    url: '/basic/admin/words',
    method: 'post',
    data: query
  })
}

export function updateWords(obj) {
  return request({
    url: '/basic/admin/words',
    method: 'put',
    data: obj
  })
}

export function deleteWords(id) {
  return request({
    url: '/basic/admin/words/' + id,
    method: 'delete'
  })
}

export function getWords(id) {
  return request({
    url: '/basic/admin/words/' + id,
    method: 'get'
  })
}
